import { publish } from '../twd'

export const processors = {}

processors.YieldBucket = ({yieldTypeMap}) => {

    if (!yieldTypeMap) return

    Object.values(yieldTypeMap).forEach(a => {
        publish('yield_bucket', {
            id: a.bucketId,
            value: a.averageYield
        })
    })
}

processors.Order = (value) => {
    publish('order_status', value)
}